import { useState } from 'react'

export default function useViewState() {
  let [id, set] = useState();
  return [id, set];
}
